// /legal/cookies — static cookies policy page
import React from 'react';

interface Props {
  onBack: () => void;
}

export function CookiesPage({ onBack }: Props) {
  return (
    <div style={pageStyle}>
      <button onClick={onBack} style={backStyle}>← Back</button>
      <article style={articleStyle}>
        <h1 style={h1Style}>Cookie Policy</h1>
        <p style={mutedStyle}>Last updated: April 2026</p>

        <Section title="Session cookie">
          <p>We set one cookie named <code style={{ fontFamily: 'monospace', fontSize: 13, background: 'var(--surface2)', padding: '1px 5px', borderRadius: 4 }}>session</code> when you sign in. It is HttpOnly and Secure, meaning it cannot be accessed by JavaScript and is only sent over HTTPS. It expires after 30 days of inactivity and is used solely to keep you logged in.</p>
        </Section>

        <Section title="Analytics">
          <p>We use Cloudflare Web Analytics to understand aggregate traffic patterns (page views, countries, referrers). Cloudflare Web Analytics does not use cookies or fingerprint individual users. No personal data is collected by the analytics script.</p>
        </Section>

        <Section title="Third-party cookies">
          <p>mylodic itself does not set any third-party cookies. Embedded Spotify or YouTube players loaded by your browser may set their own cookies per those platforms' policies.</p>
        </Section>

        <Section title="Managing cookies">
          <p>You can delete the session cookie by logging out, or clear it from your browser's developer tools. Disabling cookies will prevent you from staying logged in.</p>
        </Section>
      </article>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section style={{ marginTop: 28 }}>
      <h2 style={{ fontSize: 15, fontWeight: 700, marginBottom: 8 }}>{title}</h2>
      <div style={{ fontSize: 14, color: 'var(--text-muted)', lineHeight: 1.7 }}>{children}</div>
    </section>
  );
}

const pageStyle: React.CSSProperties = {
  maxWidth: 620,
  margin: '0 auto',
  padding: '24px 20px 64px',
};

const backStyle: React.CSSProperties = {
  fontSize: 13,
  color: 'var(--text-muted)',
  marginBottom: 28,
  display: 'inline-block',
  cursor: 'pointer',
};

const articleStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
};

const h1Style: React.CSSProperties = {
  fontSize: 24,
  fontWeight: 800,
  letterSpacing: '-0.02em',
  marginBottom: 4,
};

const mutedStyle: React.CSSProperties = {
  fontSize: 12,
  color: 'var(--text-muted)',
};
